import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import DualStateControlledTooltip from "app/pages/sales-intelligence/common-components/DualStateControlledTooltip/DualStateControlledTooltip";

export const StyledLeadPriorityTooltip = styled(DualStateControlledTooltip)`
    && {
        background-color: ${colorsPalettes.carbon[0]};
        color: ${colorsPalettes.carbon[400]};
        border-radius: 20px;
        box-shadow: 0 0 20px 0 rgba(14, 30, 62, 0.22);
        padding: 0;
        width: 372px;
        min-width: 372px;
    }
`;
